import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "AtFooter-top" };
const _hoisted_2 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("footer", {
        class: _normalizeClass(["AtFooter", { 'inner-page-style': _ctx.isInnerPageStyle }])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "beforeLinks"),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
                return (_openBlock(), _createElementBlock("a", {
                    class: _normalizeClass(["AtFooter-links text-gray-900", _ctx.isInnerPageStyle ? 'font-body-small-b' : 'font-subtext-b']),
                    key: link.link,
                    href: link.link
                }, _toDisplayString(link.label), 11, _hoisted_2));
            }), 128))
        ]),
        _renderSlot(_ctx.$slots, "afterLinks")
    ], 2));
}
